import { ProductCardProps } from "../Components/ProductCard";
import { getData } from "./general/httpDataService";

export const getBehandelingenProducts = (): Promise<ProductCardProps[]> => {
    return getData<ProductCardProps[]>("/assets/behandelingen20251229.json");
}